import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';

const ImageCarousel = ({ images, className = '' }) => {
  return (
    <Carousel
      data-testid="image-carousel"
      opts={{ align: 'start', loop: true }}
      className={`w-full ${className}`}
    >
      <CarouselContent className="-ml-4">
        {images.map((image, index) => (
          <CarouselItem key={index} className="pl-4 basis-full md:basis-1/2 lg:basis-1/3">
            <div className="image-zoom aspect-[4/5] bg-stone-100">
              <img
                src={image.src}
                alt={image.alt || `Image ${index + 1}`}
                className="w-full h-full object-cover editorial-image"
              />
            </div>
            {image.caption && (
              <p className="mt-4 text-stone-500 text-sm font-light">{image.caption}</p>
            )}
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className="hidden md:flex -left-4 bg-white border-stone-200 hover:bg-stone-100 text-stone-900" />
      <CarouselNext className="hidden md:flex -right-4 bg-white border-stone-200 hover:bg-stone-100 text-stone-900" />
    </Carousel>
  );
};

export default ImageCarousel;
